const CHART_COLORS = ['rgba(0,156,255,0.75)', 'rgba(205,61,255,0.75)', 'rgba(67,67,72,0.75)', 'rgba(192,192,192,0.75)', 'rgba(247,163,92,0.75)'];

const chartOptions = {
  plotOptions: {
    stacking: 'normal',
    lineColor: '#ffffff',
    lineWidth: 1,
    marker: {
      lineWidth: 1,
      lineColor: '#ffffff',
    },
  },

  chart: {
    type: 'area'
  },
  title: {
    text: 'Versions by Country'
  },
  credits: {
    enabled: false
  },
};



const CHART_CONFIG_DAY = {
  ...chartOptions,
  tooltip: {
    headerFormat: '<b>{point.x:%Y-%m-%d}</b><br/>',
    pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
  },
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      day: '%Y-%m-%d'
    }
  },
};
  const CHART_CONFIG_HOUR = {
  ...chartOptions,
  tooltip: {
    headerFormat: '<b>{point.x:%H:%M}</b><br/>',
    pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
  },
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      hour: '%H:%M',
      day: '%H:%M',
    }
  },
} as any;

function timeStringToTimestamp(timeString) {
  const [hours, minutes] = timeString.split(':').map(Number);
  return Date.UTC(1970, 0, 1, hours, minutes);
}

export {
  CHART_COLORS,
  CHART_CONFIG_DAY,
  CHART_CONFIG_HOUR,
  timeStringToTimestamp,
};